import type { UsageInfo } from '@reqshare/shared';

const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:3000';

export async function getUsage(token: string): Promise<UsageInfo> {
  const response = await fetch(`${API_BASE}/users/me/usage`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch usage');
  }

  return response.json();
}
